/* eslint-disable react/prop-types */
import React from 'react';
import { isEmpty } from 'lodash';
import { FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';

const MapLayers = ({
  uploadedGeoJSONLayer,
  isMapEditable = true,
  featureGroupRef,
  hasLayer,
  _onCreate,
  _onEdited,
  _onDeleted
}) => {
  if (
    uploadedGeoJSONLayer &&
    !isEmpty(uploadedGeoJSONLayer) &&
    featureGroupRef.current
  ) {
    featureGroupRef.current.clearLayers();
    featureGroupRef.current.addLayer(uploadedGeoJSONLayer);
  }

  return (
    <FeatureGroup ref={featureGroupRef}>
      <EditControl
        position="topright"
        onCreated={_onCreate}
        onEdited={_onEdited}
        onDeleted={_onDeleted}
        draw={{
          circlemarker: false,
          marker: false,
          polyline: false,
          rectangle: hasLayer ? false : { shapeOptions: { color: '#ff0000' } },
          circle: hasLayer ? false : { shapeOptions: { color: '#ff0000' } },
          polygon: hasLayer
            ? false
            : {
                showArea: true,
                shapeOptions: { color: '#ff0000' }
              }
        }}
        edit={{
          edit: isMapEditable,
          remove: isMapEditable
        }}
      />
    </FeatureGroup>
  );
};
export default MapLayers;
